import React from 'react';
import AttendenceTypeList from './AttendenceTypeSettings/AttendenceTypesList';
import CompanySettingsForm from './CompanySettings/CompanySettingsForm';

export default function TimesheetSettingsPage() {
  return (
    <div>
      <AttendenceTypeList />
      <CompanySettingsForm />
    </div>
  );
}
